// extracted by extract-css-chunks-webpack-plugin
module.exports = {"footer":"footer-3HO8r5L7","foot_link":"foot_link-1JE49VNO","list":"list-1rcr86mF","link":"link-3_91sjQ0","copyright":"copyright-57GLGq1Y"};